export default "__VITE_ASSET__1CIdmNtB__"